import { render } from "./BksWall.vue?vue&type=template&id=094e8463&scoped=true&ts=true"
import script from "./BksWall.vue?vue&type=script&lang=ts"
export * from "./BksWall.vue?vue&type=script&lang=ts"

import "./BksWall.vue?vue&type=style&index=0&id=094e8463&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-094e8463"]])

export default __exports__